import type { User } from 'containers/Users/types';

/** Subscription plan literals sent by the backend in `User.planType`. */
export const PLAN_TYPES = {
  EARLY: 'EARLY',
} as const;

/** Whether the user is on the Early plan, which only gets demo views of paid modules. */
export const isEarlyPlan = (user?: Pick<User, 'planType'> | null): boolean => user?.planType === PLAN_TYPES.EARLY;
